import { render, staticRenderFns } from "./DashboardCobranca.vue?vue&type=template&id=098d3143"
import script from "./DashboardCobranca.vue?vue&type=script&lang=js"
export * from "./DashboardCobranca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports